import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as InfoIcon } from 'assets/icons/info.svg';
import Button from 'components/Button/Button';
import { BUTTON_VARIANT } from 'constants/interfaces';

import type IImpactScenariosEmptyState from './interfaces/IImpactScenariosEmptyState';

import styles from './sass/ImpactScenariosEmptyState.module.scss';

function ImpactScenariosEmptyState({
  isCreating,
  onStartNewAnalysis,
}: IImpactScenariosEmptyState): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div className={styles.emptyState}>
      <InfoIcon className={styles.emptyIcon} aria-hidden="true" />
      <p className={styles.emptyDescription}>
        {t('valueChainMap.impactScenariosEmptyDescription')}
      </p>
      <Button
        title={t('valueChainMap.startNewAnalysis')}
        labelKey="valueChainMap.startNewAnalysis"
        variant={BUTTON_VARIANT.primary}
        onClick={onStartNewAnalysis}
        isLoading={isCreating}
        className={styles.emptyAction}
      />
    </div>
  );
}

export default ImpactScenariosEmptyState;
